export enum WorkflowStatus {
  INACTIVE = 'INACTIVE',
  ACTIVE = 'ACTIVE',
}
